<template>
<div :class="{'pp-content':1, 'pp-content--fullscreen': $root.view != 'mobile' }">
    <div @click="$root.mobileBack()" v-if="$root.view == 'mobile'" class="pp-mobile-back pp-mobile-back--light">
        <i class="fa fa-fw fa-angle-left"></i>
    </div>
    <loading-indicator v-if="loading"></loading-indicator>
    <div v-if="artist" class="pp-artist-view">
        <div class="pp-artist-view__sidebar" :style="{ backgroundImage: 'url(\''+artist.image+'\')' }">
            <div class="pp-artist-view__sidebar__container">
                <div class="pp-artist-view__title">{{ artist.display_name }}</div>
                <div class="pp-artist-view__stats">
                    {{ totalAlbums }} albums, {{ totalTracks}} tracks
                </div>
                <div class="pp-artist-view__summary" v-html="artist.description"></div>
            </div>
        </div>
        <div class="pp-artist-view__main" @scroll="onScroll">
            <div class="pp-tabs">
                <div class="pp-tabs__headers">
                    <div :class="{'pp-tabs__headers__header':1, 'pp-tabs__headers__header--active': view == 'albums' }">
                        <router-link :to="'/browse/composers/'+artist.id">
                            Albums
                        </router-link>
                    </div>
                    <div :class="{'pp-tabs__headers__header':1, 'pp-tabs__headers__header--active': view == 'tracks' }">
                        <router-link :to="'/browse/composers/'+artist.id+'/tracks'">
                            Tracks
                        </router-link>
                    </div>
                    <div v-if="$root.view =='mobile'" :class="{'pp-tabs__headers__header':1, 'pp-tabs__headers__header--active': view == 'bio' }">
                        <router-link :to="'/browse/composers/'+artist.id+'/bio'">
                            Bio
                        </router-link>
                    </div>
                </div>
                <div v-if="view == 'albums'" class="pp-tabs__content">
                    <album-grid @paginate="loadMore"
                                :reached-end="reachedEnd"
                                :paginating="paginating"
                                :can-paginate="true"
                                :items="albums"></album-grid>
                </div>
                <div v-if="view == 'tracks'" class="pp-tabs__content">
                    <track-list @paginate="loadMore"
                                :reached-end="reachedEnd"
                                :paginating="paginating"
                                :can-paginate="true"
                                :items="tracks"></track-list>
                </div>
                <div v-if="view == 'bio'" class="pp-tabs__content">
                    <div v-html="artist.description" class="pp-artist-view__summary pp-artist-view-_summary--mobile"></div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>


<script>
import TrackList from '../components/TrackList.vue';
import AlbumGrid from '../components/AlbumGrid.vue';
import LoadingIndicator from '../components/LoadingIndicator.vue';
import EventBus from '../EventBus.js';
import { api } from '../API.js';

export default {
    name: 'view-composer',
    components: {
        LoadingIndicator,
        TrackList,
        AlbumGrid
    },
    watch: {
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.loading = true;

            this.view = this.$route.params.view || 'albums';

            console.log('fetchData');
            this.page = 1;
            this.paginating = false;
            this.load();


            api.get('/composers/{{id}}', {
                id: this.$route.params.id
            }, {}, (data) => {
                this.artist = data.composer;
                this.totalTracks = data.track_count;
                this.totalAlbums = data.album_count;
                this.loading = false;
            }, () => {
                console.log('Error!');
            });
        },
        loadMore() {
            if (this.paginating) { return; }

            this.page++;
            this.paginating = true;
            this.load(true);
        },
        load() {
            if (this.view == 'tracks') {
                api.get('/tracks', {}, {
                    composer_id: this.$route.params.id,
                    limit: 100,
                    page: this.page,
                    with: ['albums']
                }, (data) => {
                    if (this.paginating) {
                        this.paginating = false;
                        if (data.tracks.length == 0) {
                            this.reachedEnd = true;
                        } else {
                            for (var item of data.tracks) {
                                this.tracks.push(item);
                            }
                        }
                    } else {
                        this.tracks = data.tracks;
                        this.loading = false;
                    }
                }, () => {
                    console.log('Error!');
                });
            } else {
                api.get('/albums', {}, {
                    composer_id: this.$route.params.id,
                    limit: 100,
                    page: this.page,
                    with: ['albums']
                }, (data) => {
                    if (this.paginating) {
                        this.paginating = false;
                        if (data.albums.length == 0) {
                            this.reachedEnd = true;
                        } else {
                            for (var item of data.albums) {
                                this.albums.push(item);
                            }
                        }
                    } else {
                        this.albums = data.albums;
                        this.loading = false;
                    }
                }, () => {
                    console.log('Error!');
                });
            }

        },
        onScroll(e) {
            var target = e.target || e.srcElement;

            if (this.scrollTimeout) { return; }
            this.scrollTimeout = true;
            setTimeout(() => {
                this.scrollTimeout = false;
                var fromBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
                EventBus.emit('navigation.scrolling', {
                    fromBottom
                });
            }, 200);

            var fromBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
            EventBus.emit('navigation.scrolling', {
                fromBottom
            });
        }
    },
    mounted() {
        this.fetchData();
    },
    data() {
        return {
            loading: true,
            artist: null,
            tracks: [],
            albums: [],
            view: 'albums',
            totalAlbums: 0,
            totalTracks: 0,

            page: 1,
            reachedEnd: false,
            paginating: false,

            scrollTimeout: false
        };
    },

}
</script>



// WEBPACK FOOTER //
// ViewComposer.vue?92d5153e